import { waitForContent } from "../shared/utility";
import { initializePage } from "../shared/page-init";
import { validatePage } from "../shared/validation";
import { previous } from "../shared/navigation";
import { renderNavButtons, renderQuestionOkNotOk, renderQuestionOkNotOkNa } from "../shared/templates";

const app = window.app;

export class MbOutUponDelivery extends HTMLElement {
	async connectedCallback() {
		await waitForContent("mbOutUponDelivery");

		this.innerHTML = app.content.mbOutUponDelivery;

		// Render the navigation buttons component
		this.querySelector("#nav-slot").replaceWith(renderNavButtons("backButton17", "nextButton17"));

		//prettier-ignore
		const questions = [
			["mer-incoming",    "All incoming points completed / resolved",      false],
			["mer-fuel",        "Fuel tank full",                                 true],
			["mer-phev",        "PHEV battery 100% (utilize battery hold)",       true],
			["mer-bev",         "BEV battery 90% minimum",                        true],
			//["mer-insurance",   "Valid insurance and registration in vehicle",   false],
			//["mer-incident",    "Incident form in vehicle",                      false],
			["mer-trip-counter","Reset trip counter",                            false],
			["mer-nav-hist",    "Delete navigation history",                     false],
			["mer-connected",   "Delete all connected devices",                  false],
			["mer-equalizer",   "Equalizer to zero and sound focus to 'Front'",  false],
			["mer-kinetics",    "Reset seat kinetics",                           false],
         ["mer-warnings",    "No warning lights displayed on dashboard",      false],
		];

		for (const [name, label, na] of questions) {
			const render = na ? renderQuestionOkNotOkNa : renderQuestionOkNotOk;
			this.querySelector(`#${name}-slot`).replaceWith(render(name, label, 17));
		}

		this.addEventListener("ionViewWillEnter", async () => {
			const pageElement = this;
			await initializePage(17, pageElement);
		});

		this.addEventListener("ionViewDidEnter", async () => {
			const currentRoute = app.routes.mbOutUponDelivery;
			const nextPage = app.flowManager.getNext(currentRoute);
			const prevPage = app.flowManager.getPrevious(currentRoute);

			if (prevPage) app.state.backButton.addEventListener("click", () => previous(prevPage.route));
			if (nextPage) app.state.nextButton.addEventListener("click", () => validatePage(nextPage.route));
		});
	}
}
